import React from 'react'

const IconUser = () => {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.50098 11.0312C12.2402 11.0312 14.3135 8.53906 14.3135 5.24121C14.3135 2.60938 12.1113 0.375 9.50098 0.375C6.89062 0.375 4.68848 2.60938 4.68848 5.24121C4.68848 8.53906 6.76172 11.0312 9.50098 11.0312ZM9.50098 2.04004C11.166 2.04004 12.6377 3.54395 12.6377 5.24121C12.6377 7.59375 11.2949 9.36621 9.50098 9.36621C7.70703 9.36621 6.36426 7.59375 6.36426 5.24121C6.36426 3.54395 7.83594 2.04004 9.50098 2.04004ZM2.29297 19.625L2.44336 18.0244C2.77637 14.8018 6.4502 14.0928 9.50098 14.0928C12.5518 14.0928 16.2256 14.8018 16.5586 18.0137L16.709 19.625H18.4277L18.2773 17.8525C17.9014 14.3398 14.8076 12.4062 9.50098 12.4062C4.19434 12.4062 1.10059 14.3398 0.724609 17.8633L0.574219 19.625H2.29297Z"
        fill="white"
      />
    </svg>
  )
}

export default IconUser
